export const SubscriptionType = Object.freeze({
    ONE_TIME: Symbol('ONE_TIME'),
    RECURRING: Symbol('RECURRING'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    const items = [];
    const types = Object.getOwnPropertyNames(SubscriptionType);

    for (const type of types) {
        items.push({[value]: type, [text]: getTypeText(type)});
    }

    return items;
}

export function getTypeColor(type) {
    if ('symbol' !== typeof type) {
        type = SubscriptionType[String(type).toUpperCase()];
    }

    return {
        [SubscriptionType.ONE_TIME]: 'black--text',
        [SubscriptionType.RECURRING]: 'purple--text',
    }[type];
}

export function getTypeName(type) {
    if ('symbol' !== typeof type) {
        type = SubscriptionType[String(type).toUpperCase()];
    }

    return {
        [SubscriptionType.ONE_TIME]: 'ONE_TIME',
        [SubscriptionType.RECURRING]: 'RECURRING',
    }[type];
}

export function getTypeText(type) {
    if ('symbol' !== typeof type) {
        type = SubscriptionType[String(type).toUpperCase()];
    }

    return {
        [SubscriptionType.ONE_TIME]: 'Jednorazowa',
        [SubscriptionType.RECURRING]: 'Odnawialna',
    }[type];
}

export function isOneTime(type) {
    return SubscriptionType.ONE_TIME === SubscriptionType[String(type).toUpperCase()];
}

export function isRecurring(type) {
    return SubscriptionType.RECURRING === SubscriptionType[String(type).toUpperCase()];
}
